module.exports = __webpack_public_path__ + "static/media/sz.a32ffc74.svg";